module.exports = __webpack_public_path__ + "static/stay-cool-0f7b4c70638d08c4b3a3810fc16e9d38.png";